<div
  class="p-4 side"
  [ngClass]="toggleOpen ? 'open' : 'closed'"
  style="position: fixed; left: 0px; top: 60px"
  (mouseenter)="toggleOpen = !toggleOpen"
  (mouseleave)="toggleOpen = !toggleOpen"
>
  <div class="row justify-content-center my-2 mb-4">
    <i [ngClass]="!toggleOpen ? 'fak fa-bars-close fa-lg' : 'fak fa-bars-open fa-lg'"></i>
  </div>

  <div class="row justify-content-center">
    <button
      [ngClass]="!toggleOpen ? 'btn btn-icon btn-icon-closed' : 'btn btn-primary btn-icon-open'"
      routerLink="/report/list"
      routerLinkActive="active-link"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <i class="fa-regular fa-file-chart-column fa-lg" style="width: 30px"></i>
      <a style="font-size: 16px; text-transform: capitalize">{{ toggleOpen ? 'Relatórios' : '' }}</a>
    </button>
  </div>

  <div class="sidebar-footer">
    <img [src]="org?.imageURL ?? 'assets/icons/camera.svg'" class="org-img" />
    <div class="d-flex">
      <span *ngIf="toggleOpen" style="font-size: 11px; line-height: 15px">{{
        org?.name ?? 'Organização não informada'
      }}</span>
    </div>
  </div>
</div>
